import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"
import {
	resolveSidebarLayout,
	toStoredSidebarLayout,
} from "@productlane/lib/src/sidebar-layout"

import type { MutatorTx } from "../schema"
import type { MembershipUpdate, SetSidebarLayoutArgs } from "../types"

export const membershipMutators = {
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: MembershipUpdate }) => {
			await tx.mutate.memberships.update({
				...args,
				id: args.id,
				updatedAt: Date.now(),
			})
		},
	),
	// Scoped to the caller's own row and normalized, since it runs as written on the server.
	setSidebarLayout: defineMutator(
		async ({
			tx,
			args,
			ctx: auth,
		}: {
			tx: MutatorTx
			args: SetSidebarLayoutArgs
			ctx: ZeroJwtPayload
		}) => {
			const membership = await tx.query.memberships
				.where("workspaceId", auth.workspaceId)
				.where("userId", auth.userId)
				.one()
				.run()
			if (!membership) return
			await tx.mutate.memberships.update({
				id: membership.id,
				sidebarLayout: toStoredSidebarLayout(resolveSidebarLayout(args.layout)),
				updatedAt: Date.now(),
			})
		},
	),
}
